import React, { useState, useCallback } from 'react';

import { ImageListItem, Paper, Typography, ImageList } from '@mui/material';
import Lightbox from 'react-image-lightbox';

import '../styles.scss';

export const ScreenShots = ({ attachments }) => {
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);
  const openLightbox = useCallback((index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  }, []);

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const next = () => {
    if (currentImage < attachments?.length - 1) {
      setCurrentImage((prevState) => prevState + 1);
    }
  };

  const prev = () => {
    if (currentImage > 0) {
      setCurrentImage((prevState) => prevState - 1);
    }
  };

  return (
    <Paper
      sx={{
        borderColor: 'purple',
        borderRadius: 10,
        boxShadow: '0 2px 4px -2px rgba(0,0,0,0.24), 0 4px 24px -2px rgba(0, 0, 0, 0.2)',
        p: { md: 2, sm: 1, xs: 1 }
      }}
      elevation={9}>
      <Typography
        variant="h6"
        noWrap
        component="div"
        sx={{
          display: { xs: 'block', sm: 'block' },
          marginLeft: '10px'
        }}>
        {'ScreenShots'}
      </Typography>
      <ImageList sx={{ minHeight: 300 }} variant="quilted" cols={3} rowHeight={164} gap={20}>
        {attachments.map((item, index) => (
          <ImageListItem
            key={index}
            cols={item.cols || 1}
            rows={item.rows || 1}
            onClick={() => openLightbox(index)}>
            <img
              key={index}
              src={item.logo_url}
              srcSet={item.logo_url}
              loading="lazy"
              width="100%"
              height="100%"
              style={{ objectFit: 'fill' }}
            />
          </ImageListItem>
        ))}
      </ImageList>

      {viewerIsOpen && (
        <Lightbox
          mainSrc={`${attachments[currentImage].logo_url}`}
          nextSrc={`${attachments[(currentImage + 1) % attachments.length].logo_url}`}
          prevSrc={`${attachments[(currentImage - 1) % attachments.length]?.logo_url}`}
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() => prev()}
          onMoveNextRequest={() => next()}
        />
      )}
    </Paper>
  );
};
